import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="grid-pattern opacity-30" />
        <div className="absolute top-1/4 -left-32 w-96 h-96 bg-[#D3FF62]/10 rounded-full blur-[128px] pointer-events-none" />
        <div className="absolute bottom-1/4 -right-32 w-96 h-96 bg-[#004534]/20 rounded-full blur-[128px] pointer-events-none" />
      </div>

      <div className="relative z-10 text-center max-w-2xl mx-auto">
        {/* 404 Number */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <h1 
            className="text-[clamp(8rem,25vw,14rem)] font-black leading-none tracking-tighter"
            style={{ 
              WebkitTextStroke: '3px #D3FF62',
              WebkitTextFillColor: 'transparent'
            }}
          >
            404
          </h1>
        </motion.div>

        {/* Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Page Not Found
          </h2>
          <p className="text-white/60 text-lg mb-10 max-w-md mx-auto">
            Looks like this play went out of bounds. The page you're looking for doesn't exist or has been moved.
          </p>
        </motion.div>

        {/* CTAs */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <Link 
            to="/" 
            className="btn-primary text-lg px-8 py-4"
            onClick={() => window.scrollTo(0, 0)}
          >
            <Home size={20} />
            Back to Home
          </Link>
          <button 
            onClick={() => window.history.back()}
            className="btn-secondary text-lg px-8 py-4"
          >
            <ArrowLeft size={20} />
            Go Back
          </button>
        </motion.div>

        {/* Logo */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="mt-16"
        >
          <Link to="/" className="inline-block opacity-60 hover:opacity-100 transition-opacity">
            <img 
              src="/logo-full.png" 
              alt="OmniSportsGroup" 
              className="h-8 w-auto"
            />
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
